(function () {
    "use strict";

    angular
        .module("app")
        .directive("patternColorways", patternColorways);

    function patternColorways(PatternService, PrototypeService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.loadItem = { PrototypeSeasonalId: null };
                scope.loadData = function (id) {
                    if (id !== undefined) {
                        if (scope.$root.cId) {
                            PrototypeService.getPrototypeSeasonalDetails(scope.$root.cId).then(function (response) {
                                scope.colorway = response;
                                PrototypeService.getPrototypeDetails(scope.colorway.PrototypeId).then(function (response) {
                                    scope.colorways = [];
                                    scope.colorways.push(response);
                                    scope.loadItem.PrototypeSeasonalId = scope.colorway.PrototypeSeasonalId;
                                    scope.$root.cName = response.PrototypeName;
                                });
                            });
                        } else {
                            PatternService.getPatternPrototypes(id).then(function (data) {
                                scope.colorways = data;
                            });
                        }
                    }
                };

                scope.loadData(scope.patternId);

                scope.$watch("patternId", function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        scope.loadData(newValue);
                });

                scope.$watch("updateDirectives", function (newValue) {
                    if (typeof newValue == 'undefined')
                        return;
                    scope.loadData(newValue);
                });
            },
            scope: { patternId: "=", updateDirectives: "=" },
            templateUrl: templateUrl("app/directives/linePlan/patternColorways.directive.html")
        };
    }
})();
